module.exports = __webpack_public_path__ + "static/media/corvallis.07f3fb86.svg";